export const BranchDetailsTabKeys = [
  'manage',
  'operations',
  'history',
  'review',
  'errors',
  'shadowed',
  'workspaces',
  'advanced',
] as const

export type BranchDetailsTabKey = (typeof BranchDetailsTabKeys)[number]

export type BranchDetailsTab = {
  key: BranchDetailsTabKey
  title: string
}

export const isBranchDetailsTabKey = (
  value: string,
): value is BranchDetailsTabKey =>
  BranchDetailsTabKeys.includes(value as BranchDetailsTabKey)

export const tab = (
  key: BranchDetailsTabKey,
  title: string,
): BranchDetailsTab => ({ key, title })
